export default __webpack_public_path__ + "static/media/hummus_with_greek_olive.c96a1ecf.jpg";